import { create } from 'zustand';

// Ephemeral, purely client-side UI state (never persisted, never
// fetched) — sidebar collapse, active modal, current viewer zoom.
// This is the kind of state that should NOT live in React Query
// (it's not server data) and doesn't need Context (nothing needs to
// wrap children to provide it).
interface UiState {
  isSidebarCollapsed: boolean;
  activeModal: string | null;
  toggleSidebar: () => void;
  openModal: (id: string) => void;
  closeModal: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  isSidebarCollapsed: false,
  activeModal: null,
  toggleSidebar: () => set((s) => ({ isSidebarCollapsed: !s.isSidebarCollapsed })),
  openModal: (id) => set({ activeModal: id }),
  closeModal: () => set({ activeModal: null }),
}));
